// extracted by mini-css-extract-plugin
export default {"headers":"Account_headers__60znj","card":"Account_card__60XQa"};